import React, { useState } from "react";
import axios from "axios";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import "./DzoSeparatedUnsubscribe.scss";
import DzoSeparatedUnsubscribeDisplay, {
  Unsubscribe,
} from "./DzoSeparatedUnsubscribe.styled";

const DEACTIVATE_API =
  "https://vas1.grand-hub.com/api/PlayIt/ooredoo-alg-d-migrat/deactivate";

function DzoSeparatedUnsubscribe({ t }) {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const handleUnsubscribe = async (e) => {
    e.preventDefault();

    const phoneNumber = phone.replace(/[^0-9]/g, "");
    if (!phoneNumber) {
      setErrorMsg(t("Empty Phone Number Or Password"));
      setShowError(true);
      return;
    }

    setLoading(true);
    setShowError(false);
    setShowSuccess(false);

    try {
      const res = await axios.get(`${DEACTIVATE_API}?phone=${phoneNumber}`);

      if (res.data && (res.data.success === true || res.data.status === true)) {
        setSuccessMsg(
          res.data.message || t("Unsubscribed successfully")
        );
        setShowSuccess(true);
        setPhone("");
      } else {
        const responseMessage =
          (res.data && res.data.message) ||
          (res.data && res.data.data && res.data.data.message) ||
          t("Unsubscribe.UNSUBSCRIBE_ERROR");
        setErrorMsg(responseMessage);
        setShowError(true);
      }
    } catch (error) {
      const apiErrorMessage =
        error.response &&
        error.response.data &&
        error.response.data.message;
      setErrorMsg(
        apiErrorMessage ||
          t("Something went wrong! Please make sure you have the correct number inserted or try again later.")
      );
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DzoSeparatedUnsubscribeDisplay>
      {showError ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMsg}</Trans>
        </FloatingAlert>
      ) : null}

      {showSuccess ? (
        <FloatingAlert type={"success"}>
          <Trans>{successMsg}</Trans>
        </FloatingAlert>
      ) : null}

      <Unsubscribe>
        <div className="sad"></div>
        <p className="confirmQues">
          <Trans>unsubscribeConfirm.you_want_unsubscribe?</Trans>
        </p>

        <form className="unsubscribe-form" onSubmit={handleUnsubscribe}>
          <div className="phone-input-group">
            <input
              type="text"
              className="input prefix-input"
              value="+213"
              disabled
            />
            <input
              type="text"
              className="input phone-input"
              placeholder="XX XXX XX XX"
              value={phone}
              maxLength="10"
              onChange={(e) =>
                setPhone(e.target.value.replace(/[^0-9]/g, ""))
              }
            />
          </div>

          <button
            className="btn unsubscribe-btn"
            type="submit"
            disabled={loading || !phone}
          >
            <Trans>unsubscribe</Trans>
          </button>
        </form>

        <div className="normBtn">
          <Link className="btn" to="/">
            <Trans>back_home</Trans>
          </Link>
        </div>
      </Unsubscribe>
    </DzoSeparatedUnsubscribeDisplay>
  );
}

export default withTranslation()(DzoSeparatedUnsubscribe);
